"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLayerImages = exports.getStopsSource = void 0;
/* eslint-disable */
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var antd_1 = require("antd");
var small_1 = __importDefault(require("../tooltips/small"));
var mapbox_gl_1 = __importDefault(require("mapbox-gl"));
var types_1 = require("../types");
var long_1 = __importDefault(require("../tooltips/long"));
var utils_1 = require("./utils");
var icons_1 = require("../../../icons");
var common_1 = require("./common");
var common_2 = require("./common");
var getStopsSource = function (_a) {
    var points = _a.points, shouldCluster = _a.shouldCluster, onClick = _a.onClick, toolTipType = _a.toolTipType;
    var stops = points;
    var stopId;
    var markers = {};
    var markersOnScreen = {};
    return {
        layers: [
            {
                data: {
                    id: "stops-unclustered-point",
                    type: "circle",
                    source: "stops",
                    layout: {},
                    filter: ["!", ["has", "point_count"]],
                    paint: {
                        "circle-color": ["get", "circleColor"],
                        "circle-radius": ["get", "circleRadius"],
                        "circle-stroke-width": ["get", "circleStroke"],
                        "circle-stroke-color": ["get", "circleStrokeColor"],
                    },
                },
                onClick: function (e, map) {
                    var _a, _b, _c, _d;
                    // @ts-ignore
                    var features = map.queryRenderedFeatures(e.point, {
                        layers: ["stops-unclustered-point"],
                    });
                    // @ts-ignore
                    var center = (_b = (_a = features[0]) === null || _a === void 0 ? void 0 : _a.geometry) === null || _b === void 0 ? void 0 : _b.coordinates;
                    map.easeTo({
                        center: center,
                    });
                    if (onClick) {
                        onClick((_d = (_c = features[0]) === null || _c === void 0 ? void 0 : _c.properties) === null || _d === void 0 ? void 0 : _d.id);
                    }
                    var toolTipData = features[0];
                    var stopData = {};
                    if (toolTipData.properties && toolTipData.properties["stop-data"]) {
                        stopData = JSON.parse(toolTipData.properties["stop-data"]);
                    }
                    var placeholder = document.createElement("div");
                    var borderColor = toolTipData.properties["border-color"];
                    var backgroundColor = toolTipData.properties["background-color"];
                    var textColor = toolTipData.properties["text-color"];
                    var Content = (react_1.default.createElement(react_1.default.Fragment, null, toolTipType === types_1.ToolTipType.LongContainer ? (react_1.default.createElement(long_1.default, { data: stopData })) : (react_1.default.createElement(small_1.default, { borderColor: borderColor, backgroundColor: backgroundColor, data: stopData, textColor: textColor }))));
                    react_dom_1.default.render(Content, placeholder);
                    new mapbox_gl_1.default.Popup({
                        maxWidth: toolTipType === types_1.ToolTipType.LongContainer ? "540px" : "240px",
                    })
                        // @ts-ignore
                        .setLngLat(features[0].geometry.coordinates)
                        .setDOMContent(placeholder)
                        .addTo(map);
                },
                onMouseEnter: function (e, map) {
                    // @ts-ignore
                    map.getCanvas().style.cursor = "pointer";
                },
                onMouseLeave: function (e, map) {
                    map.getCanvas().style.cursor = "";
                },
                onMouseMove: function (e, map) {
                    map.getCanvas().style.cursor = "pointer";
                },
            },
        ],
        sourceId: "stops",
        source: {
            type: "geojson",
            cluster: shouldCluster,
            clusterMaxZoom: 25,
            clusterRadius: 15,
            generateId: true,
            data: {
                type: "FeatureCollection",
                features: stops.map(function (stop) {
                    var _a, _b;
                    var textColor = "#FFFFFF";
                    var imgSrc = "";
                    var circleStrokeColor = "#FFFFFF";
                    var circleColor = "#000000";
                    var borderColor = "#FFFFFF";
                    var backgroundColor = "#000000";
                    var circleStroke = 2;
                    var circleRadius = 4;
                    var textOffset = [-0.3, -0.6];
                    var stopNumberLength = utils_1.getStopNumberLength(stop.stopData.stopNumber);
                    switch (stop.stopType) {
                        case types_1.StopType.COMPLETE_INQUIRY_STOP:
                            imgSrc = "complete-inquiry-stop";
                            textColor = "#FFFFFF";
                            circleColor = "#7CC81B";
                            circleStrokeColor = "#FFFFFF";
                            circleStroke = 1;
                            circleRadius = 5;
                            backgroundColor = "#7CC81B";
                            borderColor = "#7CC81B";
                            textOffset = [0.9, 0.4];
                            break;
                        case types_1.StopType.COMPLETE_CONTAINER_STOP:
                            imgSrc = "complete-container-stop";
                            textColor = "#FFFFFF";
                            circleColor = "#7CC81B";
                            circleStrokeColor = "#FFFFFF";
                            circleStroke = 1;
                            circleRadius = 5;
                            backgroundColor = "#7CC81B";
                            borderColor = "#7CC81B";
                            textOffset = [0.8, 0.4];
                            break;
                        case types_1.StopType.PENDING_INQUIRY_STOP:
                            textColor = "#000000";
                            imgSrc = "pending-inquiry-stop";
                            circleColor = "#FFFFFF";
                            circleStrokeColor = "#909DA9";
                            backgroundColor = "#FFFFFF";
                            borderColor = "#909DA9";
                            textOffset = [0.85, 0.4];
                            break;
                        case types_1.StopType.PENDING_CONTAINER_STOP:
                            imgSrc = "pending-container-stop";
                            textColor = "#000000";
                            circleColor = "#FFFFFF";
                            circleStrokeColor = "#909DA9";
                            backgroundColor = "#FFFFFF";
                            borderColor = "#909DA9";
                            textOffset = [0.85, 0.4];
                            break;
                        case types_1.StopType.CREATED_INQUIRY_EMPTIED:
                            imgSrc = "created-inquiry-emptied";
                            textColor = "#FFFFFF";
                            circleColor = "#FF4D4F";
                            circleStrokeColor = "#FFFFFF";
                            circleStroke = 1;
                            circleRadius = 5;
                            backgroundColor = "#FF4D4F";
                            borderColor = "#FF4D4F";
                            textOffset = [0.9, 0.4];
                            break;
                        case types_1.StopType.CREATED_INQUIRY_NON_EMPTIED:
                            imgSrc = "created-inquiry-non-emptied";
                            textColor = "#FFFFFF";
                            circleColor = "#FF4D4F";
                            circleStrokeColor = "#FFFFFF";
                            circleStroke = 1;
                            circleRadius = 5;
                            backgroundColor = "#FF4D4F";
                            borderColor = "#FF4D4F";
                            textOffset = [0.9, 0.4];
                            break;
                        case types_1.StopType.CURRENT_CONTAINER_STOP:
                            imgSrc = "current-container-stop-" + stopNumberLength;
                            textColor = "#000000";
                            circleColor = "#FFFFFF";
                            circleStrokeColor = "#1890ff";
                            backgroundColor = "#FFFFFF";
                            borderColor = "#1890ff";
                            textOffset = [1.5, 0.4];
                            break;
                        case types_1.StopType.CURRENT_INQUIRY_STOP:
                            imgSrc = "current-inquiry-stop-" + stopNumberLength;
                            textColor = "#000000";
                            circleColor = "#FFFFFF";
                            circleStrokeColor = "#1890ff";
                            backgroundColor = "#FFFFFF";
                            borderColor = "#1890ff";
                            textOffset = [1.5, 0.4];
                            break;
                        default:
                            break;
                    }
                    return {
                        type: "Feature",
                        properties: {
                            id: stop.id,
                            "stop-data": stop.stopData,
                            "text-color": textColor,
                            "image-icon": imgSrc,
                            "image-icon-hover": imgSrc + "-hover",
                            "stop-number": stop.stopData.stopNumber,
                            circleColor: circleColor,
                            circleStrokeColor: circleStrokeColor,
                            circleStroke: circleStroke,
                            circleRadius: circleRadius,
                            "background-color": backgroundColor,
                            "border-color": borderColor,
                            "text-offset": textOffset,
                            "stop-type": stop.stopType,
                        },
                        geometry: {
                            type: "Point",
                            coordinates: [
                                (_a = stop.stopData.location) === null || _a === void 0 ? void 0 : _a.longitude,
                                (_b = stop.stopData.location) === null || _b === void 0 ? void 0 : _b.latitude,
                            ],
                        },
                    };
                }),
            },
        },
        images: exports.getLayerImages(),
        onRender: function (e, map) {
            var newMarkers = {};
            // @ts-ignore
            var features = map.querySourceFeatures("stops");
            var clusterSource = map.getSource("stops");
            var clusterCount = 0;
            var _loop_1 = function (feature) {
                // @ts-ignore
                var coords = feature.geometry.coordinates;
                var props = feature.properties;
                if (!(props === null || props === void 0 ? void 0 : props.cluster))
                    return "continue";
                clusterCount += 1;
                var id = props.cluster_id;
                var point_count = props.point_count;
                // @ts-ignore
                clusterSource.getClusterExpansionZoom(id, function (err, zoom) {
                    if (err)
                        return;
                    // @ts-ignore
                    clusterSource.getClusterLeaves(id, point_count, 0, 
                    // @ts-ignore
                    function (err, aFeatures) {
                        // @ts-ignore
                        var stopNumbers = aFeatures.map(function (x) { return x.properties["stop-number"]; });
                        var left = -3;
                        var top = 4;
                        var startStopNumber = Math.min.apply(Math, stopNumbers);
                        var endStopNumber = Math.max.apply(Math, stopNumbers);
                        var currentPendingMultipleStops = aFeatures.filter(
                        // @ts-ignore
                        function (afeature) {
                            return afeature.properties["stop-type"].includes("current");
                        }).length > 0;
                        var stopTypes = [];
                        var isCurrent = currentPendingMultipleStops;
                        // @ts-ignore
                        var checkAndPush = function (features, type, typesArray) {
                            features.filter(
                            // @ts-ignore
                            function (afeature) {
                                return afeature.properties["stop-type"].includes(type);
                            }).length > 0 && typesArray.push(type);
                        };
                        var typesToCheck = [
                            types_1.StopType.COMPLETE_CONTAINER_STOP,
                            types_1.StopType.COMPLETE_INQUIRY_STOP,
                            types_1.StopType.CREATED_INQUIRY_EMPTIED,
                            types_1.StopType.CREATED_INQUIRY_NON_EMPTIED,
                            types_1.StopType.PENDING_CONTAINER_STOP,
                            types_1.StopType.PENDING_INQUIRY_STOP,
                            types_1.StopType.CURRENT_INQUIRY_STOP,
                            types_1.StopType.CURRENT_CONTAINER_STOP,
                        ];
                        typesToCheck.map(function (type) {
                            return checkAndPush(aFeatures, type, stopTypes);
                        });
                        var digitLength = (startStopNumber.toString().length +
                            endStopNumber.toString().length).toString();
                        if (currentPendingMultipleStops) {
                            left = 5.5;
                            isCurrent = true;
                        }
                        var clusterData = common_1.getClusterDataStops(stopTypes, digitLength, isCurrent);
                        var imgSrc = clusterData.imgSrc;
                        var imgSrcHover = clusterData.imgSrcHover;
                        var width = clusterData.width;
                        var height = clusterData.height;
                        var marker = markers[id];
                        if (!marker) {
                            var el_1 = document.createElement("div");
                            var placeholder_1 = document.createElement("div");
                            var Content = (react_1.default.createElement(common_1.PopoverListWrapper, { dataSource: aFeatures, renderItem: function (_a) {
                                    var properties = _a.properties;
                                    var borderColor = properties["border-color"];
                                    var backgroundColor = properties["background-color"];
                                    var textColor = properties["text-color"];
                                    var stopData = {};
                                    if (properties && properties["stop-data"]) {
                                        stopData = properties["stop-data"];
                                    }
                                    return (react_1.default.createElement(antd_1.List.Item, null,
                                        react_1.default.createElement(small_1.default, { borderColor: borderColor, backgroundColor: backgroundColor, data: stopData, textColor: textColor })));
                                } }));
                            react_dom_1.default.render(Content, placeholder_1);
                            el_1.addEventListener("click", function () {
                                if (zoom >= 26) {
                                    // @ts-ignore
                                    marker.setPopup(new mapbox_gl_1.default.Popup({
                                        maxWidth: "240px",
                                    })
                                        // @ts-ignore
                                        .setLngLat(coords)
                                        .setDOMContent(placeholder_1)
                                        .addTo(map));
                                }
                                else {
                                    map.easeTo({
                                        center: coords,
                                        zoom: zoom,
                                    });
                                }
                            });
                            el_1.addEventListener("mouseenter", function () {
                                el_1.getElementsByTagName("img")[0].src = imgSrcHover;
                            });
                            el_1.addEventListener("mouseleave", function () {
                                el_1.getElementsByTagName("img")[0].src = imgSrc;
                            });
                            el_1.innerHTML = "\n                    <div style=\"position: relative; cursor: pointer\">\n                      <div style=\"position: absolute; font-weight: 600;  margin-top:" + top + "px; text-align: center; font-size: 13px; left: " + left + "px; display: flex; justify-content: center; width: 100%; color: #909DA9;\">\n                        <span>" + startStopNumber + " - " + endStopNumber + "</span>\n                      </div>\n                      <img src='" + imgSrc + "' width=" + width + " height=" + height + " >\n                    </div>";
                            marker = markers[id] = new mapbox_gl_1.default.Marker({
                                element: el_1,
                            }).setLngLat(coords);
                        }
                        newMarkers[id] = marker;
                        marker.addTo(map);
                        // for every marker we've added previously, remove those that are no longer visible
                        for (var id_1 in markersOnScreen) {
                            if (!newMarkers[id_1])
                                markersOnScreen[id_1].remove();
                        }
                        markersOnScreen = newMarkers;
                    });
                });
            };
            // @ts-ignore
            for (var _i = 0, features_1 = features; _i < features_1.length; _i++) {
                var feature = features_1[_i];
                _loop_1(feature);
            }
            if (clusterCount === 0) {
                for (var id in markersOnScreen) {
                    markersOnScreen[id].remove();
                }
            }
        },
    };
};
exports.getStopsSource = getStopsSource;
var getLayerImages = function () {
    return [
        {
            name: "complete-container-stop",
            image: common_1.getSvgImage(function () { return react_1.default.createElement(icons_1.StopMarkerFilled, { color: "#85B400", size: common_2.IMAGE_SIZE }); }, 25 * common_2.IMAGE_SCALE, 28 * common_2.IMAGE_SCALE),
            external: false,
        },
        {
            name: "complete-container-stop-hover",
            image: common_1.getSvgImage(function () { return react_1.default.createElement(icons_1.StopMarkerFilled, { color: "#78A200", size: common_2.IMAGE_SIZE }); }, 25 * common_2.IMAGE_SCALE, 28 * common_2.IMAGE_SCALE),
            external: false,
        },
        {
            name: "complete-inquiry-stop",
            image: common_1.getSvgImage(function () { return react_1.default.createElement(icons_1.StopMarkerFilled, { color: "#D0E989", size: common_2.IMAGE_SIZE }); }, 25 * common_2.IMAGE_SCALE, 28 * common_2.IMAGE_SCALE),
            external: false,
        },
        {
            name: "complete-inquiry-stop-hover",
            image: common_1.getSvgImage(function () { return react_1.default.createElement(icons_1.StopMarkerFilled, { color: "#BBD27B", size: common_2.IMAGE_SIZE }); }, 25 * common_2.IMAGE_SCALE, 28 * common_2.IMAGE_SCALE),
            external: false,
        },
        {
            name: "created-inquiry-emptied",
            image: common_1.getSvgImage(function () { return (react_1.default.createElement(icons_1.StopMarkerFilled, { color: "#FFA940", strokeColor: "#FFA940", size: common_2.IMAGE_SIZE })); }, 25 * common_2.IMAGE_SCALE, 28 * common_2.IMAGE_SCALE),
            external: false,
        },
        {
            name: "created-inquiry-emptied-hover",
            image: common_1.getSvgImage(function () { return (react_1.default.createElement(icons_1.StopMarkerFilled, { color: "#E5983A", strokeColor: "#E5983A", size: common_2.IMAGE_SIZE })); }, 25 * common_2.IMAGE_SCALE, 28 * common_2.IMAGE_SCALE),
            external: false,
        },
        {
            name: "created-inquiry-non-emptied",
            image: common_1.getSvgImage(function () { return (react_1.default.createElement(icons_1.StopMarkerFilled, { color: "#FF4D4F", strokeColor: "#FF4D4F", size: common_2.IMAGE_SIZE })); }, 25 * common_2.IMAGE_SCALE, 28 * common_2.IMAGE_SCALE),
            external: false,
        },
        {
            name: "created-inquiry-non-emptied-hover",
            image: common_1.getSvgImage(function () { return (react_1.default.createElement(icons_1.StopMarkerFilled, { color: "#E54547", strokeColor: "#E54547", size: common_2.IMAGE_SIZE })); }, 25 * common_2.IMAGE_SCALE, 28 * common_2.IMAGE_SCALE),
            external: false,
        },
        {
            name: "pending-container-stop",
            image: common_1.getSvgImage(function () { return (react_1.default.createElement(icons_1.StopMarkerOutlined, { color: "#ffffff", strokeColor: "#909DA9", size: common_2.IMAGE_SIZE })); }, 25 * common_2.IMAGE_SCALE, 28 * common_2.IMAGE_SCALE),
            external: false,
        },
        {
            name: "pending-container-stop-hover",
            image: common_1.getSvgImage(function () { return (react_1.default.createElement(icons_1.StopMarkerOutlined, { color: "#F2F2F2", strokeColor: "#909DA9", size: common_2.IMAGE_SIZE })); }, 25 * common_2.IMAGE_SCALE, 28 * common_2.IMAGE_SCALE),
            external: false,
        },
        {
            name: "pending-inquiry-stop",
            image: common_1.getSvgImage(function () { return (react_1.default.createElement(icons_1.StopMarkerOutlined, { color: "#ffffff", strokeColor: "#FFA940", size: common_2.IMAGE_SIZE })); }, 25 * common_2.IMAGE_SCALE, 28 * common_2.IMAGE_SCALE),
            external: false,
        },
        {
            name: "pending-inquiry-stop-hover",
            image: common_1.getSvgImage(function () { return (react_1.default.createElement(icons_1.StopMarkerOutlined, { color: "#F2F2F2", strokeColor: "#FFA940", size: common_2.IMAGE_SIZE })); }, 25 * common_2.IMAGE_SCALE, 28 * common_2.IMAGE_SCALE),
            external: false,
        },
        {
            name: "current-container-stop-1",
            image: common_1.getSvgImage(function () { return (react_1.default.createElement(icons_1.StopMarkerCurrent1d, { color: "#ffffff", strokeColor: "#909DA9", size: common_2.IMAGE_SIZE })); }, 36 * common_2.IMAGE_SCALE, 28 * common_2.IMAGE_SCALE),
            external: false,
        },
        {
            name: "current-container-stop-1-hover",
            image: common_1.getSvgImage(function () { return (react_1.default.createElement(icons_1.StopMarkerCurrent1d, { color: "#F2F2F2", strokeColor: "#909DA9", size: common_2.IMAGE_SIZE })); }, 36 * common_2.IMAGE_SCALE, 28 * common_2.IMAGE_SCALE),
            external: false,
        },
        {
            name: "current-container-stop-2",
            image: common_1.getSvgImage(function () { return (react_1.default.createElement(icons_1.StopMarkerCurrent2d, { color: "#ffffff", strokeColor: "#909DA9", size: common_2.IMAGE_SIZE })); }, 39 * common_2.IMAGE_SCALE, 28 * common_2.IMAGE_SCALE),
            external: false,
        },
        {
            name: "current-container-stop-2-hover",
            image: common_1.getSvgImage(function () { return (react_1.default.createElement(icons_1.StopMarkerCurrent2d, { color: "#F2F2F2", strokeColor: "#909DA9", size: common_2.IMAGE_SIZE })); }, 36 * common_2.IMAGE_SCALE, 28 * common_2.IMAGE_SCALE),
            external: false,
        },
        {
            name: "current-container-stop-3",
            image: common_1.getSvgImage(function () { return (react_1.default.createElement(icons_1.StopMarkerCurrent3d, { color: "#ffffff", strokeColor: "#909DA9", size: common_2.IMAGE_SIZE })); }, 43 * common_2.IMAGE_SCALE, 28 * common_2.IMAGE_SCALE),
            external: false,
        },
        {
            name: "current-container-stop-3-hover",
            image: common_1.getSvgImage(function () { return (react_1.default.createElement(icons_1.StopMarkerCurrent3d, { color: "#F2F2F2", strokeColor: "#909DA9", size: common_2.IMAGE_SIZE })); }, 43 * common_2.IMAGE_SCALE, 28 * common_2.IMAGE_SCALE),
            external: false,
        },
        {
            name: "current-inquiry-stop-1",
            image: common_1.getSvgImage(function () { return (react_1.default.createElement(icons_1.StopMarkerCurrent1d, { color: "#ffffff", strokeColor: "#FFA940", size: common_2.IMAGE_SIZE })); }, 36 * common_2.IMAGE_SCALE, 28 * common_2.IMAGE_SCALE),
            external: false,
        },
        {
            name: "current-inquiry-stop-1-hover",
            image: common_1.getSvgImage(function () { return (react_1.default.createElement(icons_1.StopMarkerCurrent1d, { color: "#F2F2F2", strokeColor: "#FFA940", size: common_2.IMAGE_SIZE })); }, 36 * common_2.IMAGE_SCALE, 28 * common_2.IMAGE_SCALE),
            external: false,
        },
        {
            name: "current-inquiry-stop-2",
            image: common_1.getSvgImage(function () { return (react_1.default.createElement(icons_1.StopMarkerCurrent2d, { color: "#ffffff", strokeColor: "#FFA940", size: common_2.IMAGE_SIZE })); }, 39 * common_2.IMAGE_SCALE, 28 * common_2.IMAGE_SCALE),
            external: false,
        },
        {
            name: "current-inquiry-stop-2-hover",
            image: common_1.getSvgImage(function () { return (react_1.default.createElement(icons_1.StopMarkerCurrent2d, { color: "#F2F2F2", strokeColor: "#FFA940", size: common_2.IMAGE_SIZE })); }, 39 * common_2.IMAGE_SCALE, 28 * common_2.IMAGE_SCALE),
            external: false,
        },
        {
            name: "current-inquiry-stop-3",
            image: common_1.getSvgImage(function () { return (react_1.default.createElement(icons_1.StopMarkerCurrent3d, { color: "#ffffff", strokeColor: "#FFA940", size: common_2.IMAGE_SIZE })); }, 43 * common_2.IMAGE_SCALE, 28 * common_2.IMAGE_SCALE),
            external: false,
        },
        {
            name: "current-inquiry-stop-3-hover",
            image: common_1.getSvgImage(function () { return (react_1.default.createElement(icons_1.StopMarkerCurrent3d, { color: "#F2F2F2", strokeColor: "#FFA940", size: common_2.IMAGE_SIZE })); }, 43 * common_2.IMAGE_SCALE, 28 * common_2.IMAGE_SCALE),
            external: false,
        },
    ];
};
exports.getLayerImages = getLayerImages;
